import { useTranslation } from 'react-i18next'

import { Alert, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { manageCarrierServiceTypes } from '@/common/constants'
import LocationsSelector from '@/configuration/components/LocationsSelector/LocationsSelector'

import { getLocationPayload, getSelectedLocationId } from '../helpers'
import useValidateUrl from '../hooks/useValidateUrl/useValidateUrl'
import ManageCarrierService from './ManageCarrierService/ManageCarrierService'
import PickUpPointMethodSkeleton from './PickUpPointMethodSkeleton/PickUpPointMethodSkeleton'
import { logisticsManagementExplanation, pickUpPointsExplanation } from './constants'

const PickUpPointMethod = ({
  config,
  onChange,
  errors,
  subscriptionPlan,
  carriers,
  onCarrierChange,
  carrierServices,
  manageCarrierService,
  onManageCarrierServiceChange,
  isLoadingCarrierServices,
  disabled,
}) => {
  const { t } = useTranslation()
  const { error, validateUrl } = useValidateUrl()

  const handleChangePickUpPointsUrl = e => {
    onChange({ url: e.target.value })
    validateUrl(e.target.value)
  }

  const handleChangeLocation = location => onChange(getLocationPayload(location))

  const isManual = manageCarrierService === manageCarrierServiceTypes.manual
  const carriersOptions = isManual ? carriers : carrierServices
  const carrier = isManual ? config?.carrier : config?.carrier_service
  const supportsPickUpPoints = !!carrier?.is_pickup_point

  if (isLoadingCarrierServices) {
    return (
      <>
        <Text type="bodyMRegular">{t(logisticsManagementExplanation)}</Text>
        <PickUpPointMethodSkeleton />
      </>
    )
  }

  return (
    <>
      <Text type="bodyMRegular">{t(logisticsManagementExplanation)}</Text>
      <ManageCarrierService
        carriers={carriersOptions}
        carrier={carrier}
        subscriptionPlan={subscriptionPlan}
        onCarrierChange={onCarrierChange}
        manageCarrierService={manageCarrierService}
        onManageCarrierServiceChange={onManageCarrierServiceChange}
        errors={errors}
        disabled={disabled}
      />
      {supportsPickUpPoints && <Alert type="info">{t(pickUpPointsExplanation)}</Alert>}
      <LocationsSelector value={getSelectedLocationId(config)} onChange={handleChangeLocation} errors={errors} />
      {!supportsPickUpPoints && (
        <InputWithLabel
          label={t('Listado puntos entrega')}
          fullWidth
          value={config?.url}
          onChange={handleChangePickUpPointsUrl}
          error={error}
          helperText={error}
          disabled={disabled}
        />
      )}
    </>
  )
}

export default PickUpPointMethod
